
import { MECHANICAL_ASPECT_METADATA } from './mechanical-aspect.metadata';
import { MechanicalAspect } from './mechanical-aspect.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class MechanicalAspectEntityDecoratorBase extends GenericEntityDecorator<MechanicalAspect, number> {
  constructor() {
    super(MECHANICAL_ASPECT_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.aspectAssetId == null) {
      return null;
    }
    return parseInt(params.aspectAssetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: MechanicalAspect): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




